// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./css/example.less
 ** module id = 5
 ** module chunks = 0
 **/